import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import qs from 'qs'
import ToastComponent from './components/Loading/Toast.vue';

import {Quill} from 'vue-quill-editor'
window.Quill = Quill;
const scriptEl = document.createElement('script');
scriptEl.charset = 'utf-8';
scriptEl.src = "../src/assets/js/quillvideo.js";
const head = document.head || document.getElementsByTagName('head')[0];
head.appendChild(scriptEl);

// 使用element框架
Vue.use(ElementUI);
// 引入axios
Vue.prototype.$axios = axios  // this.$axios即可调用axios的方法
Vue.prototype.$qs = qs  // this.$qs即可调用qs的方法
Vue.prototype.bus = new Vue();

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);


import Vant from 'vant';
Vue.use(Vant);
import 'vant/lib/index.css';



//创建Toast组件实例
const Toast = {
    install(Vue){
      const ToastConstructor = Vue.extend(ToastComponent);
      const instance = new ToastConstructor();
      instance.$mount(document.createElement('div'));
      document.body.appendChild(instance.$el);

      Vue.prototype.$toast = (message, duration) => {
        instance.show(message, duration);
      }
    }
};

//注册Toast为VUe组件
Vue.use(Toast);

// axios:默认url配置 
axios.defaults.baseURL = "https://www.shqpfz.com:12800/"


Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {

  // chrome

  document.body.scrollTop = 0

  // firefox

  document.documentElement.scrollTop = 0

  // safari

  window.pageYOffset = 0

  next()

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
